<template>
  <div v-if="previousStep != null" class="back-btn-relative">
    <div class="back-btn-wrapper">
      <button class="back-btn-wrapper-button" @click="navigateBack">
        Retour
      </button>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    previousStep() {
      return this.$store.getters.previousStep;
    }
  },
  methods: {
    navigateBack() {
      this.$store.dispatch("navigateBack");
    }
  }
};
</script>

<style lang="scss" scoped>
.back-btn-relative {
  @include media("<tablet") {
    border-radius: #{$s-border-radius - 1} 0 0 0;
    padding: 10px 20px;
    min-height: 56px;
  }
}

.back-btn-wrapper {
  @include media(">=tablet") {
    background: $c-white;
    border-radius: #{$s-border-radius - 1} 0 0 0;
    padding: 24px 20px 10px;
    width: 230px;
    height: 135px;
    background: url("~@/assets/images/back-button-bg.svg") no-repeat top
      left/contain;
  }
}

.back-btn-wrapper-button {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: $c-text;
  font-size: 20px;
  font-weight: 500;
  transition: color $s-transition, transform 0.5s $s-transition-easing-bounce;

  &::before {
    content: "";
    display: block;
    mask: url("~@/assets/images/back-button-icon.svg") no-repeat center/contain;
    width: 33px;
    height: 33px;
    background: currentColor;
    margin-right: 16px;
    transition: all 0.6s;

    @include ie-only {
      mask: none;
      background: url("~@/assets/images/back-button-icon.svg") no-repeat
        center/contain;
    }

    @include media(">=tablet") {
      width: 49px;
      height: 49px;
    }
  }

  &:active,
  &:focus {
    outline: 0;
  }

  &:hover {
    color: $c-primary;
    transform: translateX(-5px);
  }

  @include media(">=tablet") {
    font-size: 24px;
  }
}
</style>
